export enum OrderStatus {
  APPROVED = 'approved',
  FINISHED = 'finished',
  CLOSED = 'closed',
  INITIAL = 'initial',
  CANCELED = 'canceled'
}
